import React, { useEffect, useState } from 'react';
import '../../css/remixicon/remixicon.css'; 
import 'aos/dist/aos.css'; 
import SolutionInfo from "./SolutionInfo";
import SolutionPoss from "./SolutionPoss";

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Solution = () => {
    useEffect(() => {
        
    }, []);

    const [activeCategory, setActiveCategory] = useState("Information");

    const handleFilter = (categoryId) => {
      setActiveCategory(categoryId);
    };

    const categories = [
        { id: "Information", name: "솔루션 안내" },
        { id: "Possession", name: "보유 솔루션" }
    ];

    const categoryComponent = {
        Information: <SolutionInfo />,
        Possession: <SolutionPoss />
    };
    
    return(
        <div className="flex-1">
            <section className="page_title solution">
               <div className="page_title_bg solution"></div>
               <div className="page_title_text">
                   <h2>위즈팩토리 솔루션</h2>
                    <p>위즈팩토리의 다양한 솔루션을 경험해보세요.</p>
               </div>
            </section>
            {categories && (
                <nav id="bo_cate">
                    <h2>카테고리</h2>
                    <ul id="bo_cate_ul">
                        {categories.map((category) => (
                            <li
                                key={category.id}
                                className={activeCategory === category.id ? "bo_cate_on" : ""}
                                onClick={() => handleFilter(category.id)}
                            >
                                {category.name}
                            </li>
                        ))}
                    </ul>
                </nav>
            )}
            <React.Fragment>
                {categoryComponent[activeCategory]}
            </React.Fragment>
        </div>
    );
};

export default Solution;